import adv from "./adv"
import biometry from "./biometry"
import countries from "./countries"
import exams from "./exams"
import pregnancy from "./pregnancy"
import registration from "./registration"

export default {
	countries,
	exams,
	pregnancy,
	adv,
	biometry,
	registration
}
